import React from "react";
import {
  LegalPage,
  LegalSection,
  LegalRoute,
} from "../components/Legal";

export default function Cookies({ language = "de" }) {
  const de = language === "de";

  return (
    <LegalPage
      title={de ? "Cookies" : "Cookies"}
      subtitle={
        de
          ? "Was diese Website auf Ihrem Gerät speichert — und was nicht."
          : "Qué guarda este sitio en su dispositivo y qué no."
      }
      updated={de ? "Stand: September 2026" : "Actualizada en septiembre de 2026"}
    >
      <LegalSection title={de ? "Kurz gesagt" : "En resumen"}>
        <p>
          {de
            ? "Diese Website setzt keine Cookies zur Analyse, zur Werbung oder zur Wiedererkennung über mehrere Seiten hinweg. Es gibt daher nichts zu «akzeptieren» oder «ablehnen»: Es ist nichts abzulehnen da."
            : "Este sitio no utiliza cookies de análisis, de publicidad ni de reconocimiento entre páginas. Por eso no hay nada que «aceptar» o «rechazar»: no hay nada que rechazar."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "Der einzige Eintrag" : "La única entrada"}
      >
        <p>
          {de
            ? "Wenn Sie den Hinweis am unteren Seitenrand mit «Verstanden» schließen, legt der Browser im lokalen Speicher (localStorage) einen Eintrag mit dem Namen «cookie-consent» und dem Wert «accepted» ab. Er dient allein dazu, den Hinweis nicht bei jedem Besuch erneut anzuzeigen."
            : "Cuando cierra el aviso del pie de página con «Entendido», el navegador guarda en el almacenamiento local (localStorage) una entrada llamada «cookie-consent» con el valor «accepted». Sirve únicamente para no volver a mostrarle el aviso en cada visita."}
        </p>
        <p>
          {de
            ? "Dieser Eintrag enthält keine personenbezogenen Daten, wird nicht an uns oder an Dritte übertragen, läuft nicht ab und bleibt auf Ihrem Gerät. Wenn Sie den Hinweis nicht schließen, wird gar nichts gespeichert. Im privaten Fenster oder bei blockiertem Speicher versucht die Seite es nicht erneut."
            : "Esa entrada no contiene datos personales, no se transmite a nosotros ni a terceros, no caduca y permanece en su dispositivo. Si no cierra el aviso, no se guarda nada. En una ventana privada o con el almacenamiento bloqueado, la página no vuelve a intentarlo."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "Was nicht passiert" : "Lo que no ocurre"}
      >
        <p>
          {de
            ? "Keine Analysedienste (kein Google Analytics, keine Statistik-Pixel), keine Werbenetzwerke, keine Social-Media-Buttons, die im Hintergrund Daten senden, und keine externen Schriften: Alle Schriften dieser Seite liegen auf unserem eigenen Server."
            : "Ningún servicio de análisis (ni Google Analytics ni píxeles de estadística), ninguna red publicitaria, ningún botón de redes sociales que envíe datos por detrás y ninguna tipografía externa: todas las fuentes de esta página se sirven desde nuestro propio servidor."}
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "Ausnahme: das Kontaktformular" : "Excepción: el formulario de contacto"}
      >
        <p>
          {de
            ? "Auf der Seite mit dem Kontaktformular wird Cloudflare Turnstile geladen, damit keine automatisierten Nachrichten durchkommen. Dieser Dienst kann technisch notwendige Angaben Ihres Browsers und Ihre IP-Adresse an Cloudflare übermitteln; er wird auf keiner anderen Seite dieser Website geladen. Die Einzelheiten stehen in der "
            : "En la página que contiene el formulario de contacto se carga Cloudflare Turnstile, para que no lleguen mensajes automatizados. Ese servicio puede transmitir a Cloudflare datos técnicos de su navegador y su dirección IP; no se carga en ninguna otra página del sitio. Los detalles están en la "}
          <LegalRoute to={`/${language}/privacy`}>
            {de ? "Datenschutzerklärung" : "política de privacidad"}
          </LegalRoute>
          .
        </p>
      </LegalSection>

      <LegalSection
        title={de ? "Selbst löschen" : "Cómo borrarla"}
      >
        <p>
          {de
            ? "Den Eintrag entfernen Sie über die Einstellungen Ihres Browsers («Websitedaten» bzw. «Browserdaten löschen») oder indem Sie die Seitendaten für bw-verlag.at löschen. Beim nächsten Besuch erscheint der Hinweis dann wieder."
            : "Puede eliminar la entrada desde la configuración de su navegador («datos de sitios web» o «borrar datos de navegación») o borrando los datos del sitio bw-verlag.at. En la siguiente visita el aviso volverá a aparecer."}
        </p>
      </LegalSection>
    </LegalPage>
  );
}
